function use_good_check(goods, index){
    var returnValue = true;
    var use_good = goods[index];
    
    if(use_good.code == "WAITING"){ 
        goods.forEach(function(item){
            if(item.code == "AVAILABLE"){
                if(use_good.day_count_yn == item.day_count_yn 
                && use_good.hours_yn == item.hours_yn
                && use_good.end_term_yn == item.end_term_yn
                && use_good.end_time_yn == item.end_time_yn
                && use_good.seat_type_code == item.seat_type_code){
                    returnValue = false;
                }
            } 
        });
    }
    return returnValue;
}
export default {
    use_good_check:use_good_check
}


// WEBPACK FOOTER //
// ./src/assets/js/common.js